/**
 * Shapeway's Center Full layout for noty.
 */

module.exports = function($) {

  $.noty.layouts.swBottomRightContent = {
    name: 'swBottomRightContent',
    options: {},
    container: {
      object: '<ul id="noty_swBottomRightContent_layout_container" />',
      selector: 'ul#noty_swBottomRightContent_layout_container',
      style: function () {
        $(this).css({
          bottom: '20px',
          right: '20px',
          position: 'fixed',
          maxWidth: $(this).parent().width() - 40,
          height: 'auto',
          margin: 0,
          padding: 0,
          listStyleType: 'none',
          zIndex: 10000000
        });

        if (window.innerWidth < 600) {
          $(this).css({
            maxWidth: $(this).parent().width() - 10,
            right: 5
          });
        }
      }
    },
    parent: {
      object: '<li />',
      selector: 'li',
      css: {}
    },
    css: {
      display: 'none'
    },
    animation: {
      open: 'animated fadeIn', // Animate.css class names
      close: 'animated fadeOut' // Animate.css class names
    },
    addClass: ''
  };

};
